import { Component, Input } from '@angular/core';

@Component({
  templateUrl: './preloader.html',
  selector: 'preloader'
})

export class PreloaderComponent {
  @Input() pending;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/preloader/preloader.component.ts